module.exports = __webpack_public_path__ + "img/lamp.706704f1.gif";